import { db, dbStore } from '../firebase'
export const GetDetailedUsage = function (vm, historyFilters) {
  console.log('GetDetailedUsage() Started ...')
  let result = { Success: false, Data: 'No Started Yet !!' }
  let selectedMonth = vm.$moment(historyFilters.fromDate, 'YYYYMMDDHHmm').format('YYYY/MM')
  let selectedFromMonth = historyFilters.fromYear + '/' + historyFilters.fromMonth
  let selectedToMonth = historyFilters.toYear + '/' + historyFilters.toMonth
  selectedMonth = selectedToMonth
  console.log('GetDetailedUsage() historyFilters.fromDate = ' + historyFilters.fromDate)
  console.log('GetDetailedUsage() historyFilters.toDate = ' + historyFilters.toDate)
  console.log('GetDetailedUsage() selectedMonth = ' + selectedMonth)
  console.log('GetDetailedUsage() selectedFromMonth = ' + selectedFromMonth)
  console.log('GetDetailedUsage() selectedToMonth = ' + selectedToMonth)
  console.log('GetDetailedUsage() historyFilters.dealer = ' + historyFilters.dealer)
  console.log('GetDetailedUsage() historyFilters.customers.length = ' + historyFilters.customers.length)
  console.log('GetDetailedUsage() historyFilters.sites.length = ' + historyFilters.sites.length)
  // let selectedFromMonth = vm.filters.fromMonth + '/' + vm.filters.fromYear
  // let selectedToMonth = vm.filters.toMonth + '/' + vm.filters.toYear
  for (let i = 0; i < vm.report.Definition.header.elements.length; i++) {
    if (vm.report.Definition.header.elements[i].text === '#Month#') {
      console.log('vm.report.Definition.header.elements[' + i + '].text = ' + vm.report.Definition.header.elements[i].text)
      if (vm.report.Method === 'GetDetailedUsage') {
        // selectedFromMonth = historyFilters.fromMonth + '/' + historyFilterss.fromYear
        // selectedToMonth = historyFilters.toMonth + '/' + historyFilters.toYear
        if (selectedToMonth === selectedFromMonth) {
          vm.report.Definition.header.elements[i].text = 'Month: ' + selectedFromMonth
        } else {
          vm.report.Definition.header.elements[i].text = 'Month:' + selectedFromMonth + ' - ' + selectedToMonth
        }
      } else {
        vm.report.Definition.header.elements[i].text = 'Month: ' + vm.selectedMonth
      }
      vm.$forceUpdate()
    }
    break
  }
  console.log(' >>>****>>> ' + vm.report.Definition.header.elements[2].text)
  let orderBy = ''
  let orderValue = ''
  // let countersPaths = []
  let countersHistory = []
  let countersPathsFrom = []
  let countersPathsTo = []
  if (historyFilters.customers.length > 0 && historyFilters.sites.length > 0) {
    if (historyFilters.customers.length > 1) {
      orderBy = 'DealerKey'
      orderValue = historyFilters.dealer
      for (let c = 0; c < historyFilters.customers.length; c++) {
        countersPathsFrom.push('/CountersHistory/Dealers/' + historyFilters.dealer + '/Customers/' + historyFilters.customers[c].value + '/' + selectedFromMonth)
        if (selectedToMonth !== selectedFromMonth) {
          countersPathsTo.push('/CountersHistory/Dealers/' + historyFilters.dealer + '/Customers/' + historyFilters.customers[c].value + '/' + selectedToMonth)
        }
      }
    } else if (historyFilters.sites.length > 1) {
      orderBy = 'DealerCustomerKey'
      orderValue = historyFilters.dealer + '_' + historyFilters.customers[0].value
      countersPathsFrom.push('/CountersHistory/Dealers/' + historyFilters.dealer + '/Customers/' + historyFilters.customers[0].value + '/' + selectedFromMonth)
      if (selectedToMonth !== selectedFromMonth) {
        countersPathsTo.push('/CountersHistory/Dealers/' + historyFilters.dealer + '/Customers/' + historyFilters.customers[0].value + '/' + selectedToMonth)
      }
    } else {
      orderBy = 'DealerCustomerSiteKey'
      orderValue = historyFilters.dealer + '_' + historyFilters.customers[0].value + '_' + historyFilters.sites[0].value
      countersPathsFrom.push('/CountersHistory/Dealers/' + historyFilters.dealer + '/Customers/' + historyFilters.customers[0].value + '/' + selectedFromMonth)
      if (selectedToMonth !== selectedFromMonth) {
        countersPathsTo.push('/CountersHistory/Dealers/' + historyFilters.dealer + '/Customers/' + historyFilters.customers[0].value + '/' + selectedToMonth)
      }
      // add query where
    }
  }
  // result = { Success: true, Data: printers }
  console.log('GetDetailedUsage() countersPathsFrom.length = ' + countersPathsFrom.length)
  console.log('GetDetailedUsage() countersPathsTo.length = ' + countersPathsTo.length)
  console.log(countersPathsFrom)
  console.log(countersPathsTo)
  console.log('GetDetailedUsage() orderBy = ' + orderBy)
  console.log('GetDetailedUsage() orderValue = ' + orderValue)
  return GetPrinters(vm, orderBy, orderValue).then(function (resultPrinters) {
    console.log(resultPrinters)
    if (resultPrinters && resultPrinters.Success) {
      console.log('GetDetailedUsage() resultPrinters.Data.length = ' + resultPrinters.Data.length)
      return GetCounters(vm, countersPathsFrom, countersPathsTo).then(function (resultCounters) {
        // console.log(resultCounters)
        if (resultCounters && resultCounters.Success) {
          console.log('GetDetailedUsage() resultCounters.Data.length = ' + resultCounters.Data.length)
          console.log(resultCounters)
          resultPrinters.Data.forEach(function (printer) {
            let counter = resultCounters.Data.find(item => item.PrinterKey === printer.PrinterKey)
            // let counter = resultCounters.Data.find(item => item.PrinterKey === printer.PrinterSerial)
            console.log('GetDetailedUsage() counter = ' + counter)
            if (counter) {
              if (counter.StartLogged.length > 0) {
                if (counter.EndLogged.length > 0) {
                  let siteName = ''
                  for (let s = 0; s < vm.$root.sites.length; s++) {
                    if (vm.$root.sites[s].value === printer.SiteKey) {
                      siteName = vm.$root.sites[s].title
                      break
                    }
                  }
                  let customerName = ''
                  for (let c = 0; c < vm.$root.customers.length; c++) {
                    if (vm.$root.customers[c].value === printer.CustomerKey) {
                      customerName = vm.$root.customers[c].title
                      break
                    }
                  }
                  countersHistory.push({
                    PrinterModel: printer.PrinterModel,
                    PrinterSerial: printer.PrinterSerial,
                    IPAddress: printer.IPAddress,
                    MacAddress: printer.MacAddress,
                    Customer: customerName,
                    Site: siteName,
                    CustomerKey: printer.CustomerKey,
                    SiteKey: printer.SiteKey,
                    StartDateLogged: counter.StartLogged,
                    StartDate: vm.$moment(counter.StartLogged, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
                    StartCount: Number(counter.StartCounter),
                    EndDateLogged: counter.EndLogged,
                    EndDate: vm.$moment(counter.EndLogged, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
                    EndCount: Number(counter.EndCounter),
                    PageCount: Number(counter.DiffCounter)
                  })
                } else {
                  console.log('GetDetailedUsage() Missing counter.EndLogged for: ' + printer.PrinterKey)
                  console.log('printer::: >>>> counter:::')
                  console.log(printer)
                  console.log(counter)
                }
              } else {
                console.log('GetDetailedUsage() Missing counter.StartLogged for: ' + printer.PrinterKey)
                console.log('printer::: >>>> counter:::')
                console.log(printer)
                console.log(counter)
              }
            } else {
              console.log('GetDetailedUsage() Missing Counters for:' + printer.PrinterKey)
              console.log('printer::: >>>> counter:::')
              console.log(printer)
              console.log(counter)
            }
            console.log('= = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = ')
          })
          result = { Success: true, Data: countersHistory }
          return result
        } else {
          result = { Success: false, Data: resultCounters.Data }
          return result
        }
      })
    } else {
      result = { Success: false, Data: resultPrinters.Data }
      return result
    }
  })
}

function GetPrinters (vm, orderBy, orderValue) {
  console.log('GetPrinters() Started ...')
  let result = { Success: false, Data: 'Not implemented!' }
  try {
    let printers = []
    return db.ref('Printers').orderByChild(orderBy).equalTo(orderValue).once('value').then((snapPrinters) => {
      const data = snapPrinters.val()
      if (data) {
        const printerKeys = Object.keys(data)
        console.log('Found [' + printerKeys.length + '] Printers')
        for (let i = 0; i < printerKeys.length; i++) {
          let printerKey = printerKeys[i]
          let row = data[printerKey]
          let printer = {
            PrinterKey: printerKey,
            SiteKey: row.SiteKey,
            CustomerKey: row.CustomerKey,
            DealerKey: row.DealerKey,
            MacAddress: row.MacAddress ? row.MacAddress : pKey,
            PrinterModel: row.ModelName,
            IPAddress: row.IPAddress,
            PrinterSerial: row.PrinterSerial,
            PageCount: Number(row.PageCount),
            Logged: row.Logged,
            LoggedInt: row.LoggedInt
          }
          console.log('lastItem' + printer.IPAddress)
          printers.push(printer)
        }
        result = { Success: true, Data: printers }
        return Promise.resolve(result)
      } else {
        console.log('No printers found!!')
        result = { Success: true, Data: [] }
        return Promise.resolve(result)
      }
    }).catch((error) => {
      result = { Success: false, Data: error }
      // console.log(result)
      return Promise.reject(result)
    })
  } catch (generalError) {
    result = { Success: false, Data: generalError }
    return Promise.reject(result)
  }
}

// countersPaths
function GetCounters (vm, countersPathsFrom, countersPathsTo) {
  console.log('GetCounters() Started ...')
  return new Promise((resolve, reject) => {
    let result = { Success: false, Data: 'Not implemented!' }
    let promises = []
    let countersArr = {
      From: [],
      To: []
    }
    for (let i = 0; i < countersPathsFrom.length; i++) {
      console.log(countersPathsFrom[i])
      let promiseFrom = dbStore.collection(countersPathsFrom[i]).get().then(function (snapCounters) {
        console.log('snapCounters.size = ' + snapCounters.size)
        snapCounters.forEach(function (doc) {
          let docData = doc.data()
          docData['PrinterKey'] = doc.id
          countersArr.From.push(docData)
        })
        Promise.resolve({ Success: true, Data: countersArr })
      }).catch(function (err) {
        result = { Success: false, Data: err }
        return Promise.reject({ Success: false, Data: err })
      })
      promises.push(promiseFrom)
    }
    for (let i = 0; i < countersPathsTo.length; i++) {
      console.log(countersPathsTo[i])
      let promiseTo = dbStore.collection(countersPathsTo[i]).get().then(function (snapCounters) {
        console.log('snapCounters.size = ' + snapCounters.size)
        snapCounters.forEach(function (doc) {
          let docData = doc.data()
          docData['PrinterKey'] = doc.id
          countersArr.To.push(docData)
        })
        Promise.resolve({ Success: true, Data: countersArr })
      }).catch(function (err) {
        result = { Success: false, Data: err }
        return Promise.reject({ Success: false, Data: err })
      })
      promises.push(promiseTo)
    }
    Promise.all(promises).then((res) => {
      // console.log(res)
      // res.forEach((row) => {
      //   console.log(row)
      // })
      console.log('countersArr.From.length = ' + countersArr.From.length)
      console.log('countersArr.To.length = ' + countersArr.To.length)
      countersArr.From.forEach(function (counterFrom) {
        if (counterFrom.PrinterKey === '3389136599') {
          console.log('counterFrom [3389136599] :: ')
          console.log(JSON.stringify(counterFrom))
        }
        let counterTo = countersArr.To.find((c) => c.PrinterKey === counterFrom.PrinterKey)
        if (counterTo) {
          if (counterTo.PrinterKey === '3389136599') {
            console.log('counterTo [3389136599] :: ')
            console.log(JSON.stringify(counterTo))
          }
          if (counterTo.EndLogged) {
            counterFrom.EndLogged = counterTo.EndLogged
            counterFrom.EndCounter = counterTo.EndCounter
            counterFrom.DiffCounter = Number(counterFrom.EndCounter) - Number(counterFrom.StartCounter)
          }
        }
      })
      result = { Success: true, Data: countersArr.From }
      console.log('GetCounters() Ended')
      // /CountersHistory/Dealers/FdwIBsYWxXNI62fEcDiCaRc1UZt1/Customers/-M1-wBgRNTIALDwhExvf/2021/08/000000000W47A4JKPR1a
      resolve(result)
    }).catch(error => console.log(error))
  })
}



// WEBPACK FOOTER //
// ./src/plugins/detailedUsage.js